import { jsx as n, jsxs as i, Fragment as y } from "react/jsx-runtime";
import { twMerge as o, twJoin as c } from "tailwind-merge";
import { Loader as b } from "../../loader/index.mjs";
import { BASE_CLASS_NAME as C, BASE_FLEX_CLASS_NAME as M } from "../constants/base-class-name.mjs";
import { isLink as $ } from "../utils/has-href.mjs";
import j, { ButtonInnerWrapper as w } from "./button-link-wrapper.mjs";
import { getDataTestAttributes as N } from "../../../utils/get-data-test-attributes.mjs";
const q = ({
  width: u = "small",
  isFetching: e,
  backgroundColor: f,
  color: B,
  hoverColor: L,
  hoverBackgroundColor: S,
  borderColor: t,
  hoverBorderColor: v,
  loaderType: m,
  testAttributePostfix: r,
  className: x,
  buttonTextClassName: E,
  loaderClassName: _,
  as: A,
  ...k
}) => {
  const a = k, d = o(
    c(
      C,
      M,
      f,
      B,
      L,
      S,
      u === "small" ? "px-4" : "px-10",
      t && `border ${t}`,
      v,
      e && "pointer-events-none select-none"
    ),
    x
  ), p = o(
    c("absolute", e ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    _
  );
  if ($(a)) {
    const { "aria-disabled": s, ...l } = a;
    return /* @__PURE__ */ n(
      j,
      {
        as: A,
        isFetching: e,
        "aria-disabled": s || e,
        className: o(d, s && "bg-text-secondary/50 pointer-events-none"),
        ...l,
        ...N(!!r, `${r}`),
        children: /* @__PURE__ */ i(y, { children: [
          /* @__PURE__ */ n(b, { small: !0, type: m, className: p }),
          a.children
        ] })
      }
    );
  } else {
    const { disabled: s, ...l } = a;
    return /* @__PURE__ */ i(
      "button",
      {
        disabled: e || s,
        className: o(d, s && "bg-text-secondary/50 pointer-events-none"),
        ...l,
        ...N(!!r, `${r}`),
        children: [
          /* @__PURE__ */ n(b, { small: !0, type: m, className: p }),
          /* @__PURE__ */ n(w, { buttonTextClassName: E, isFetching: e, children: a.children })
        ]
      }
    );
  }
};
export {
  q as default
};
